import { useQuery } from "@tanstack/react-query";
import { getCompanyById } from "../api/companies";

export function useCompanyById(id?: string) {
    return useQuery({
        queryKey: ['company', id],
        queryFn: () => getCompanyById(id!),
        throwOnError: false,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        enabled: !!id,
        retry: 2,
        retryDelay: 1100,
    });
}